import type { HistoricNarRecommendation } from "../../../../../api/services/historicNar/types";

export interface HistoricNarFilters {
  payer: string;
  lineOfBusiness: string;
  searchText: string;
}

/** Apply the Historic NAR page's client-side payer, LOB, and free-text filters. */
export const filterHistoricNarRecommendations = (
  rows: HistoricNarRecommendation[],
  { payer, lineOfBusiness, searchText }: HistoricNarFilters,
): HistoricNarRecommendation[] => {
  const normalizedLineOfBusiness = lineOfBusiness.toLowerCase();
  const query = searchText.trim().toLowerCase();

  return rows.filter((row) => {
    if (payer && (row.payer ?? "") !== payer) return false;
    if (
      normalizedLineOfBusiness &&
      (row.line_of_business ?? "").toLowerCase() !== normalizedLineOfBusiness
    )
      return false;

    return (
      !query ||
      [row.medicine_name, row.j_code, row.plan_name].some((value) =>
        (value ?? "").toLowerCase().includes(query),
      )
    );
  });
};
